// extracted by mini-css-extract-plugin
module.exports = {"expandSearchCell":"TranslationMemorySearch_expandSearchCell__1RM5D"};